// Sample product data - replace with your API/backend calls
export const sampleProducts = [
    {
        id: 1,
        title: 'Fortune of Time',
        author: 'Billy Spark',
        isbn: '9781234567890',
        listPrice: 99,
        price: 90,
        price50: 85,
        price100: 80,
        description: '<p>Praesent vitae sodales libero. Praesent molestie orci augue, vitae euismod velit sollicitudin ac. Praesent vestibulum facilisis nibh ut ultricies.</p>',
        category: { name: 'History' },
        images: [
            { imageUrl: '/images/products/Fortune_of_Time.jpg' }
        ]
    },
    {
        id: 2,
        title: 'Dark Skies',
        author: 'Nancy Hoover',
        isbn: '9789876543210',
        listPrice: 40,
        price: 30,
        price50: 25,
        price100: 20,
        description: '<p>Praesent vitae sodales libero. Praesent molestie orci augue, vitae euismod velit sollicitudin ac.</p>',
        category: { name: 'SciFi' },
        images: [
            { imageUrl: '/images/products/Dark_Skies.jpg' }
        ]
    },
    {
        id: 3,
        title: 'Vanish in the Sunset',
        author: 'Julian Button',
        isbn: '9781111111111',
        listPrice: 55,
        price: 50,
        price50: 40,
        price100: 35,
        description: '<p>A captivating mystery novel set against the beautiful Pacific Northwest.</p>',
        category: { name: 'Fiction' },
        images: [
            { imageUrl: '/images/products/Vanish_in_the_Sunset.jpg' }
        ]
    },
    {
        id: 4,
        title: 'Cotton Candy',
        author: 'Abby Muscles',
        isbn: '9782222222222',
        listPrice: 70,
        price: 65,
        price50: 60,
        price100: 55,
        description: '<p>A delightful story about community, friendship, and sweet moments.</p>',
        category: { name: 'Children' },
        images: [
            { imageUrl: '/images/products/Cotton_Candy.jpg' }
        ]
    }
];
